var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { list: true, "list--loading": _vm.loading } },
    [
      _c("Vuetable", {
        ref: "vuetable",
        attrs: {
          "api-url": "reports",
          fields: _vm.fields,
          css: _vm.css,
          "pagination-path": "meta",
          "http-fetch": _vm.fetch,
          "append-params": _vm.reportFilters,
          "load-on-start": _vm.loadOnStart,
          "min-rows": _vm.loading ? 10 : null,
          "no-data-template": _vm.loaded ? "No reports found" : "",
        },
        on: {
          "vuetable:pagination-data": _vm.onPaginationData,
          "vuetable:loading": _vm.onLoading,
          "vuetable:loaded": _vm.onLoaded,
          "vuetable-load-error": _vm.onLoadError,
        },
      }),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "list__error" }, [
            _c("span", { staticClass: "h2" }, [
              _vm._v("Unable to load reports."),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--link",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.load.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Retry")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Pagination", {
        ref: "pagination",
        on: { "vuetable-pagination:change-page": _vm.onChangePage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }